import { EventsRootState } from "./types";

const createDefaultState = ():EventsRootState => {
  return {
    events: [],
  }
}
export default createDefaultState;